var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
var url = "https://apps.npr.org/dailygraphics/data/sheets/abortion-ballot-initiatives-20240507.json";
var dot = require("./lib/dot");
var classify = require("./lib/helpers/classify");
var template = dot.compile(require("./_section.html"));

async function fetch_data(url) {
  const response = await fetch(url);
  return response.json();
}

var onWindowLoaded = function(spreadsheet) {
  document.querySelector("#fallback").remove();

  const data = spreadsheet.data;
  const categoriesInUse = [...new Set(data.map(d => d.status))];
  const categories = Object.keys(CATEGORIES).filter(d => categoriesInUse.indexOf(d) != -1);
  let content = "";
  data.sort((a, b) => a.state > b.state);

  for (const category of categories) {
    var section = template(data.filter(d => d.status === category));
    content += section;
  }
  document.querySelector("#graphic").innerHTML = content;

  for (const object of data) {
    const path = document.querySelector("#" + classify(object.state));
    const color = CATEGORIES[object.status].color;
    path.style.fill = color;
  }

  pym.then(child => {
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
fetch_data(url).then(spreadsheet => {
  window.addEventListener("load", onWindowLoaded(spreadsheet));
});